// @flow
import * as React from 'react';
import { Form } from 'react-bootstrap';
import TextInput from './components/TextInput/TextInput';
import local from '../../../../locales/index';
import type { Props } from './Props';

const Personal = ({ user }: Props) => {
  const profile = user.profile;

  return (<Form horizontal>
    <TextInput
      title={local.firstName}
      defaultValue={`${profile.name.givenName}`}
      disabled
    />
    <TextInput
      title={local.lastName}
      defaultValue={`${profile.name.familyName}`}
      disabled
    />
    <TextInput
      title={local.gMail}
      type="mail"
      defaultValue={`${profile.emails.map(mail => mail.value).join(', ')}`}
      disabled
    />
    <TextInput
      title={local.residence}
      defaultValue={(profile.placesLived ? profile.placesLived[0].value : '')}
      disabled
    />
    <TextInput
      title={local.organizations}
      defaultValue={(profile.organizations ? profile.organizations.map(v => v.name).join(', ') : '')}
      disabled
    />
  </Form>);
};

export default Personal;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/Personal/Personal.js